import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

// https://stackoverflow.com/a/77702077/
export const twMergePrefix = extendTailwindMerge({
  prefix: 'tw',
});

export function cn(...inputs: ClassValue[]) {
  return twMergePrefix(clsx(inputs));
}
